import { render, staticRenderFns } from "./DeliveryOrderQuery.vue?vue&type=template&id=0bbc1dba&scoped=true"
import script from "./DeliveryOrderQuery.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrderQuery.vue?vue&type=style&index=0&id=0bbc1dba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc1dba",
  null
  
)

export default component.exports